import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ServiceCards from './components/ServiceCards';
import ServicesDirectory from './components/ServicesDirectory';
import FeesSection from './components/FeesSection';

export default function ServicesPage() {
  const { t } = useTranslation();
  return (
    <div className="bg-canvas font-inter">
      <Navbar />
      <main>
        <section className="pt-[72px] bg-warm-white">
          <div className="max-w-6xl mx-auto px-6 lg:px-12 pt-20 pb-16 text-center">
            <span className="text-xs uppercase tracking-[0.2em] text-sage font-inter font-medium">{t('services.hero.badge')}</span>
            <h1 className="font-cormorant text-5xl md:text-6xl lg:text-7xl font-light text-charcoal leading-[1.1] mt-5 mb-7">{t('services.hero.title')}</h1>
            <p className="text-base md:text-lg text-text-muted font-inter font-light leading-relaxed max-w-2xl mx-auto mb-10">{t('services.hero.subtitle')}</p>
            <div className="w-16 h-px bg-sage/10 mx-auto" />
          </div>
        </section>
        <ServiceCards />
        <ServicesDirectory />
        <FeesSection />
        <section className="bg-warm-white py-20 lg:py-28">
          <div className="max-w-6xl mx-auto px-6 lg:px-12 flex justify-center">
            <div className="bg-beige rounded-2xl px-12 py-16 text-center max-w-2xl w-full">
              <h2 className="font-cormorant text-4xl md:text-5xl font-light text-white leading-[1.2] mb-5">{t('services.cta.title')}</h2>
              <p className="text-sm text-white/65 font-inter leading-relaxed mb-8 max-w-md mx-auto">{t('services.cta.desc')}</p>
              <Link to="/contact" className="whitespace-nowrap inline-flex items-center justify-center px-8 py-3.5 rounded-md bg-white text-beige text-sm font-inter font-medium hover:bg-white/90 transition-colors duration-200 cursor-pointer">
                {t('services.cta.btn')}
              </Link>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
